import type { CSSProperties, SVGProps } from 'react'
import classes from './icon.module.css'

type Props = SVGProps<SVGSVGElement> & {
  className?: string
  style?: CSSProperties
}
export function MenuOpen(props: Props) {
  const { className, style, ...rest } = props

  const cls = `${classes.root} ${className || ''}`
  return (
    <svg
      aria-hidden="true"
      className={cls}
      focusable="false"
      viewBox="0 0 24 24"
      {...rest}
      data-testid="MenuOpen"
      style={style}
    >
      <path d="M3 18h13v-2H3zm0-5h10v-2H3zm0-7v2h13V6zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5z" />
    </svg>
  )
}
